import { BaseTag }   from "mixs/base/base_mixin";
import watch from "redux-watch";
import isEqual from 'is-equal';
class DeliveredCount extends BaseTag {
  init(){
    super.init();
    this.watch();
  }
}
riot.mixin('tasks.delivered-count', DeliveredCount as riot.TagMixin)
